import { useTheme } from "@mui/material/styles";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";

const ResponsiveButtonGroup = ({
  buttons,
  activeButton,
  onChange,
  bgColor = "#E59400",
  width = "500px",
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: width,
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        marginBottom: "0px",
        padding: { xs: "12px", sm: "16px" },
        display: "grid", // ✅ grid instead of flex
        gridTemplateColumns: {
          xs: "repeat(2, 1fr)",
          sm: "repeat(4, 1fr)",
          md: "repeat(6, 1fr)",
        },
        gap: { xs: "8px", sm: "12px" },
        boxShadow: `0 4px 12px ${theme.palette.grey[400]}`,
      }}
    >
      {buttons.map((button, index) => (
        <Button
          key={index}
          variant={activeButton === index ? "contained" : "outlined"}
          onClick={() => onChange(index)}
          sx={{
            width: "100%", // ✅ fill its grid cell fully
            padding: { xs: "8px 12px", sm: "10px 16px" },
            fontSize: { xs: "12px", sm: "13px", md: "14px" },
            borderRadius: "8px",
            backgroundColor: activeButton === index ? bgColor : "transparent !important",
            color: activeButton === index ? "#ffffff" : theme.palette.grey[800],
            borderColor: activeButton === index ? bgColor : theme.palette.grey[400],
            transition: "all 0.3s ease",
            whiteSpace: "nowrap", // ✅ prevent text wrapping inside button
            overflow: "hidden",
            textOverflow: "ellipsis",
            "&:hover": {
              backgroundColor: activeButton === index ? "#cc8400" : theme.palette.grey[200],
              borderColor: activeButton === index ? "#cc8400" : theme.palette.grey[500],
              color: activeButton === index ? "#ffffff" : theme.palette.grey[900],
            },
            "&:focus": {
              outline: "none !important",
              boxShadow: "none !important",
              backgroundColor: activeButton === index ? bgColor : "transparent !important",
            },
            "&:active": {
              backgroundColor: activeButton === index ? bgColor : "transparent !important",
            },
            "&.Mui-focusVisible": {
              backgroundColor: activeButton === index ? bgColor : "transparent !important",
              outline: "none !important",
              boxShadow: "none !important",
            },
            "&:focus-visible": {
              backgroundColor: activeButton === index ? bgColor : "transparent !important",
              outline: "none !important",
              boxShadow: "none !important",
            },
            textTransform: "none",
          }}
        >
          {button.label}
        </Button>
      ))}
    </Box>
  );
};

ResponsiveButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeButton: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  bgColor: PropTypes.string,
  width: PropTypes.string,
};

export default ResponsiveButtonGroup;
